export const ORGANIZATION_ROLE = {
  ADMIN: "ADMIN",
  MEMBER: "MEMBER",
} as const;

export const ORGANIZATION_ROLES = [
  ORGANIZATION_ROLE.ADMIN,
  ORGANIZATION_ROLE.MEMBER,
] as const;

/** Max length for Theme.adminRoleLabel (cosmetic UI string). */
export const ADMIN_ROLE_LABEL_MAX_LENGTH = 64;
